import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCityTheme } from "@/context/CityThemeContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const PERIODS = [
  { key: "day", label: "Hoje" },
  { key: "week", label: "7 dias" },
  { key: "month", label: "30 dias" },
];

export const useAdminFilters = () => {
  const { user } = useAuth();
  const { cities, cityName } = useCityTheme();
  const [cityId, setCityId] = useState(user?.scope === "city" ? user.city_id : "all");
  const [period, setPeriod] = useState("month");
  return { cities, cityId, setCityId, period, setPeriod, isCity: user?.scope === "city", cityName };
};

export const FilterBar = ({ f, accent }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="admin-filter-bar">
    {!f.isCity ? (
      <Select value={f.cityId} onValueChange={f.setCityId}>
        <SelectTrigger className="w-[200px] h-10 rounded-xl bg-white" data-testid="city-filter">
          <SelectValue placeholder="Cidade" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas as cidades</SelectItem>
          {f.cities.map((c) => (
            <SelectItem key={c.id} value={c.id}>{c.brand_name || c.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    ) : (
      <span data-testid="fixed-city-label" className="h-10 px-3 flex items-center rounded-xl text-sm font-bold text-white"
        style={{ background: accent }}>
        {f.cityName}/RJ
      </span>
    )}
    <div className="flex gap-1 bg-white rounded-xl p-1 border border-gray-200">
      {PERIODS.map((p) => (
        <button key={p.key} data-testid={`period-${p.key}`} onClick={() => f.setPeriod(p.key)}
          className="px-3 py-1.5 rounded-lg text-xs font-bold gf-press"
          style={f.period === p.key ? { background: accent, color: "#fff" } : { color: "#6B7280" }}>
          {p.label}
        </button>
      ))}
    </div>
  </div>
);

export const cityParam = (f) => (f.cityId && f.cityId !== "all" ? f.cityId : undefined);
